import * as React from 'react';

const Packages = ({ width, height }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    fill='none'
  >
    <path
      d='M12.0001 13.2999C11.8701 13.2999 11.7401 13.2699 11.6201 13.1999L2.79008 8.08986C2.44008 7.87986 2.31008 7.41986 2.52008 7.05986C2.73008 6.69986 3.19008 6.57986 3.55008 6.78986L12.0001 11.6799L20.4001 6.81986C20.7601 6.60986 21.2201 6.73986 21.4301 7.08986C21.6401 7.44986 21.5101 7.90986 21.1601 8.11986L12.3901 13.1999C12.2601 13.2599 12.1301 13.2999 12.0001 13.2999Z'
      fill='#333333'
    />
    <path
      d='M12 22.36C11.59 22.36 11.25 22.02 11.25 21.61V12.54C11.25 12.13 11.59 11.79 12 11.79C12.41 11.79 12.75 12.13 12.75 12.54V21.61C12.75 22.02 12.41 22.36 12 22.36Z'
      fill='#333333'
    />
    <path
      d='M12.0001 22.75C11.1201 22.75 10.2501 22.56 9.56014 22.18L4.22014 19.21C2.77014 18.41 1.64014 16.48 1.64014 14.82V9.17C1.64014 7.51 2.77014 5.59 4.22014 4.78L9.56014 1.82C10.9301 1.06 13.0701 1.06 14.4401 1.82L19.7801 4.79C21.2301 5.59 22.3601 7.52 22.3601 9.18V14.83C22.3601 16.49 21.2301 18.41 19.7801 19.22L14.4401 22.18C13.7501 22.56 12.8801 22.75 12.0001 22.75ZM12.0001 2.75C11.3701 2.75 10.7501 2.88 10.2901 3.13L4.95014 6.1C3.99014 6.63 3.14014 8.07 3.14014 9.17V14.82C3.14014 15.92 3.99014 17.36 4.95014 17.9L10.2901 20.87C11.2001 21.38 12.8001 21.38 13.7101 20.87L19.0501 17.9C20.0101 17.36 20.8601 15.93 20.8601 14.82V9.17C20.8601 8.07 20.0101 6.63 19.0501 6.09L13.7101 3.12C13.2501 2.88 12.6301 2.75 12.0001 2.75Z'
      fill='#333333'
    />
  </svg>
);

export default Packages;
